import axios from '../index'


/** 
 * 基础信息
 * id  用户ID
 */
export function getReaderById(params) {
    return axios.post('/portal/reader/getReaderById', params)
}

/** 
 * 修改昵称
 * id  用户ID
 * nickname  昵称
 */
export function updateReaderById(params) {
    return axios.post('/portal/reader/updateReaderById', params)
}

/**
 * 手机验证
 * imageVerification  图形验证码
 * tel    手机号
 * @returns {*}
 */
 export function telVerification(params) {
    return axios.post('/portal/reader/telVerification', params)
}

/** 
 * /portal/reader/getPasswordById
 * 找回密码
 * userName 
 * password
 * telCode 
 */
export function getPasswordById(params) {
    return axios.post("/portal/reader/getPasswordById", params)
}
/** 
 * /portal/collection/listCollection
 * 收藏列表
 * userName 
 * typeId
 */
export function listCollection(params) {
  return axios.post("/portal/collection/listCollection", params)
}

/**
 * 取消收藏
 * userId 用户ID
 * bookId 书籍ID   
 */
 export function deleteCollectionById(params) {
    return axios.post('/portal/collection/deleteCollectionById', params)
}

/**
 * 书籍收藏排行
 * typeId 
 */
 export function getCollectionOrder(params) {
    return axios.post('/portal/collection/getCollectionOrder', params)
}

/**
 * 浏览记录列表
 * typeId 
 */
 export function listReadHistory(params) {
    return axios.get('/portal/history/listReadHistory', {params})
}

/**
 * 收藏状态
 * userId  读者ID
 * bookId  书籍ID
 */
 export function getBookStatusByBookId(params) {
    return axios.post('/portal/collection/getBookStatusByBookId', params)
}


